export default "__VITE_ASSET__CCNQTGQa__"